import { render, staticRenderFns } from "./type-modal.vue?vue&type=template&id=1352c080&"
import script from "./type-modal.vue?vue&type=script&lang=js&"
export * from "./type-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports